import { render, staticRenderFns } from "./xeCostCardSetting.vue?vue&type=template&id=15d72aa3&scoped=true"
import script from "./xeCostCardSetting.vue?vue&type=script&lang=js"
export * from "./xeCostCardSetting.vue?vue&type=script&lang=js"
import style0 from "./xeCostCardSetting.vue?vue&type=style&index=0&id=15d72aa3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d72aa3",
  null
  
)

export default component.exports